import { DocumentNode } from '@apollo/client'
import {
  CreateWorkSpaceDocument,
  CreateWorkSpaceMutation,
  CreateWorkSpaceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type RefetchQueryDescriptor = {
  query: DocumentNode
  variables?: Record<string, unknown>
}

export const useCreateWorkSpace = () => {
  const [executeMutation] = useMutation(CreateWorkSpaceDocument, {
    extractorFn: (data: CreateWorkSpaceMutation) =>
      data.spaceControlMutations.createSpacecontrolWorkSpace,
  })

  const createWorkSpace = async (
    variables: CreateWorkSpaceMutationVariables,
    options?: { refetchQueries?: RefetchQueryDescriptor[] }
  ) => {
    return executeMutation({
      variables,
      refetchQueries: options?.refetchQueries || [],
      awaitRefetchQueries: !!options?.refetchQueries?.length,
    })
  }

  return {
    createWorkSpace,
  }
}
